import { forwardRef } from 'react';
import { useClassName } from './useClassName';
import { styleRule } from './styleRule';
import { LooseProps, splitProps } from './props';
import { textColor, textReset, TYPOGRAPHY } from './textStyles';

export const Link = forwardRef<HTMLAnchorElement, LooseProps>(function Link(props, ref) {
  const {
    variant = 'body1',
    sx,
    className,
    children,
    color,
    underline = 'always',
    ...rest
  } = props;
  const resolvedColor = textColor(color) || '#1976d2';
  const { system, dom } = splitProps(rest);
  const {
    className: resolvedClass,
    css,
    styleId,
  } = useClassName(
    sx,
    {
      ...textReset,
      ...(TYPOGRAPHY[variant] || {}),
      color: resolvedColor,
      textDecoration: underline === 'none' ? 'none' : 'underline',
      textDecorationColor: 'currentColor',
      ...system,
    },
    className,
  );
  return (
    <>
      {styleRule(styleId, css)}
      <a {...dom} ref={ref} className={resolvedClass}>
        {children}
      </a>
    </>
  );
});
